import RegisterComponent from '../components/Auth/Register';

const Register = () => {
  return <RegisterComponent />;
};

export default Register;